var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft17X13 = function SvgArrowLeft17X13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.364 7.165 5.083 5.083a1.214 1.214 0 0 0 1.717-1.718l-3-3.019h11.1a1.214 1.214 0 0 0 0-2.429h-11.1l3-3A1.221 1.221 0 1 0 5.429.364L.364 5.43A1.235 1.235 0 0 0 0 6.299a1.166 1.166 0 0 0 .364.866Z"
  })));
};
export default SvgArrowLeft17X13;